import React, {FC, useEffect, useRef, useState} from "react";
import {Modal} from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import './classForm.scss';
import ToggleSwitch from "../../ToggleSwitch";
import {Formik, Form,Field} from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import ClassroomService from "../../../../services/CourseServices/ClassroomService/classroom.service";
import {serialize} from "serializr";
import {ClassroomModel} from "../../../../models/CourseModels/ClassroomModel/classroom.model";
import { ClassFormValidation } from "../courseValidation";

interface ClassFormProps{
    title: string;
    visible: boolean;
    setVisible: Function;
    data?:any;
    refreshList?: Function;
    currentPageNumber?: number;
    boardId:number;
}

const ClassForm:FC<ClassFormProps> = (props) => {

    const {title, visible, setVisible, data, refreshList, currentPageNumber, boardId} = props;

    const formRef = useRef<any>();

    useEffect(()=>{
        setInitialValues({
            isActive: data?.isActive ? data.isActive : false,
            name: data?.name || null,
            amount: data?.amountPaise/100 || null
        })
    },[data])

    const [buttonLoading,setButtonLoading] = useState<boolean>(false);
    const [initialValues,setInitialValues] = useState<any>(
        {
            isActive: true,
            name: null,
            amount: null,
        }
    )

    const handleClose = () => {
        setVisible(false);
        formRef.current.resetForm(initialValues)
    }

    const handleSubmit = (values:any) => {
        setButtonLoading(true)
        let classroomData = serialize(ClassroomModel,values)
        if(!data) {
            classroomData.board_id = boardId;
            ClassroomService.createClassroom({class_room:classroomData},
                () => {
                    if(refreshList) refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => {},
                () => {setButtonLoading(false)},
            ).then()
        }else{
            ClassroomService.updateClassroom(data.id,{class_room:classroomData},
                () => {
                    if(refreshList) refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => {},
                () => {setButtonLoading(false)},
            ).then()
        }
    }

    return(
        <Modal title={null}
               centered
               visible={visible}
               onCancel={handleClose}
               footer={null}
               className='board-form__modal'
               closeIcon={<img src={closeIcon} alt=''/>}
        >
            <Formik initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formRef}
                    validationSchema={ClassFormValidation}
            >{({setFieldValue,values,resetForm})=> {
                return(
                    <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div className='board-form__header'>
                            <div className='board-form__title'>{title}</div>
                            <div className='board-form__toggle'>
                                <Field name="isActive" as='switch'>
                                    <ToggleSwitch checked={values.isActive}
                                                  handleChange={() => {
                                                      setFieldValue('isActive', !values.isActive)
                                                  }}
                                    />
                                </Field>
                            </div>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Name of class *</div>
                            <InputField type="text" name="name" placeholder="Class name"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Subscription cost *</div>
                            <InputField type="number" name="amount" placeholder="Enter cost" prefix='₹'/>
                        </div>

                        <div className='board-form__action'>
                            <div className='board-form__button' onClick={() => {
                                handleClose();
                                resetForm({})
                            }}>
                                <ButtonComponent buttonContent='Cancel'
                                                 type='text'
                                />
                            </div>
                            <div className='board-form__button'>
                                <ButtonComponent buttonContent={data ? 'Update' : 'Create'}
                                                 type='primary'
                                                 htmlType='submit'
                                                 loading={buttonLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )
            }}
            </Formik>
        </Modal>
    )
}

export default ClassForm;
